import React from 'react';
import { useParams } from 'react-router-dom';

import { StatementDetail } from '../components/Reconcile/StatementDetail.component';

export const StatementDetailPage: React.FC = () => {
  const { statementKey } = useParams();

  return <StatementDetail statementKey={statementKey} />;
};
